import axios, { CreateAxiosDefaults, AxiosError } from 'axios';

// Timeout constants
export const SYNC_TIMEOUT = 5 * 60 * 1000; // 5 minutes for sync operations
export const LONG_SYNC_TIMEOUT = 15 * 60 * 1000; // 15 minutes for large data sync
export const AD_COSTS_TIMEOUT = 10 * 60 * 1000; // 10 minutes for ad costs
export const DEFAULT_TIMEOUT = 30000; // 30 seconds

// Базовые настройки axios
const config: CreateAxiosDefaults = {
  timeout: DEFAULT_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Создаем экземпляр axios с настройками
const apiAxios = axios.create(config);

// --- Response Interceptor ---
apiAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    console.error('[API Error]', error.config?.url, error.response?.status, error.message);

    throw error;
  },
);

export default apiAxios;
